import { useState, useEffect } from 'react';

function useFileDragDetector(shouldListen) {
  if (shouldListen === void 0) {
    shouldListen = true;
  }
  var _useState = useState(false),
    isDragging = _useState[0],
    setIsDragging = _useState[1];
  var isDraggingFiles = function isDraggingFiles(event) {
    var _a;
    return (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.types.includes('Files');
  };
  useEffect(function () {
    var handleDragEnter = function handleDragEnter(event) {
      if (isDraggingFiles(event)) {
        setIsDragging(true);
      }
    };
    var handleDragLeave = function handleDragLeave(event) {
      if (isDraggingFiles(event)) {
        if (!event.relatedTarget) {
          setIsDragging(false);
        }
      }
    };
    var handleDrop = function handleDrop(event) {
      if (isDraggingFiles(event)) {
        setIsDragging(false);
      }
    };
    if (shouldListen) {
      document.addEventListener('dragenter', handleDragEnter);
      document.addEventListener('dragleave', handleDragLeave);
      document.addEventListener('drop', handleDrop);
      return function () {
        document.removeEventListener('dragenter', handleDragEnter);
        document.removeEventListener('dragleave', handleDragLeave);
        document.removeEventListener('drop', handleDrop);
      };
    }
    return undefined;
  }, [shouldListen]);
  return {
    isDragging: isDragging
  };
}

export { useFileDragDetector };
